import { createThemeCompiler } from '../../../utils';

export const spinnerThemeCompiler = createThemeCompiler(({ palette }) => ({
    spinner: {
        colors: {
            spinnerBackground: '#c7e0f4',
            spinnerFill: palette.themePrimary
        },
        composites: {}
    }
}));
